import React from 'react';
import { COOPERATION_URL, MARKETING_URL } from '../../utils/endpoints';
import Head from 'next/head';
const LandingMarketing = dynamic(
  () => import('../../components/LandingMarketing'),
  {
    ssr: true,
  }
);
import LandingCooperationColumn from '../../components/LandingCooperation';
import dynamic from 'next/dynamic';
import 'react-intl-tel-input/dist/main.css';
const LandingCooperation = ({
  cooperation,
  marketing,
  logo,
  name,
  discount,
  marketer_id,
  marketer_name,
  referralCode,
}) => {
  if (
    (!cooperation && !marketing) ||
    (cooperation && (!logo || !name)) ||
    (marketing && !marketer_id)
  ) {
    return (
      <>
        <Head>
          <title>حدث خطأ ❌</title>
        </Head>
        <div className="text-danger d-flex flex-column text-center justify-content-center font-weight-bold align-items-center vh-100">
          <i
            className="fas fa-exclamation-triangle fa-2x"
            style={{ fontSize: '4.2rem' }}
          ></i>
          <br />
          <h3>حدث خطأ ما، يرجى التأكد من الرابط المستخدم</h3>
        </div>
      </>
    );
  }
  return (
    <>
      <Head>
        {name && <title>فهيم | بالتعاون مع {name}</title>}
        {marketer_name && <title>فهيم | بالتعاون مع {marketer_name}</title>}
        <link rel="stylesheet" href={'/assets/criticalcss/IBM.css'} />
        <link href={'/assets/CSS/cooperation.css'} rel="stylesheet" />
      </Head>
      <main>
        {cooperation && (
          <LandingCooperationColumn
            name={name}
            logo={logo}
            discount={discount}
            referralCode={referralCode}
          />
        )}
        {marketing && <LandingMarketing marketerId={marketer_id} />}
      </main>
    </>
  );
};

export async function getServerSideProps(context) {
  const { req, query } = context;
  const { cooperation } = query;
  const referralCode = Array.isArray(query.R) ? query.R[0] : query.R;
  const host = req.headers.host;
  const isCooperation = host.split('.')[0] === 'cooperations';
  const isMarketing =
    host.split('.')[0] === 'marketing' || host.split('.')[0] === 'marketingqa';
  if (isCooperation) {
    try {
      const totalUrl = process.env.NEXT_PUBLIC_API_BASE_URL + COOPERATION_URL;
      const res = await fetch(`${totalUrl}/${cooperation}`, {
        headers: {
          'X-Internal-Token': process.env.NEXT_PUBLIC_INTERNAL_API_KEY,
        },
      });
      const data = await res.json();
      const cooperationDetails = data.data;
      return {
        props: {
          logo: cooperationDetails.logo,
          name: cooperationDetails.name,
          discount: cooperationDetails.discount,
          cooperation: true,
          referralCode: referralCode || cooperation,
        },
      };
    } catch (error) {
      return {
        props: {},
      };
    }
  } else if (isMarketing) {
    try {
      const totalUrl = process.env.NEXT_PUBLIC_API_BASE_URL + MARKETING_URL;
      const res = await fetch(`${totalUrl}/${cooperation}`, {
        headers: {
          'X-Internal-Token': process.env.NEXT_PUBLIC_INTERNAL_API_KEY,
        },
      });
      const data = await res.json();
      if (data.status !== true) {
        return {
          props: {},
        };
      }
      return {
        props: {
          marketing: true,
          marketer_id: data.data.id,
          marketer_name: data.data.name,
        },
      };
    } catch (error) {
      return {
        props: {},
      };
    }
  } else {
    return {
      notFound: true,
    };
  }
}

export default LandingCooperation;
